import { Toaster } from '@/components/ui/toaster.tsx'
import { ChakraProvider } from '@chakra-ui/react'
import React from 'react'
import { system } from './theme.ts'

export function Provider(props: Readonly<{ children: React.ReactNode }>) {
  return (
    <ChakraProvider value={system}>
      {props.children}
      <Toaster />
    </ChakraProvider>
  )
}
